module.exports = __webpack_public_path__ + "static/media/badge_supporting_3.963669dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_supporting_3.png
// module id = 227
// module chunks = 0